import React from 'react';

export interface FeeCategoryOption {
  id: string;
  name: string;
  feeCode?: string | null;
}

interface FeeCategoryMultiSelectProps {
  categories: FeeCategoryOption[];
  selectedCategoryIds: string[];
  onChange: (categoryIds: string[]) => void;
  disabled?: boolean;
}

const FeeCategoryMultiSelect: React.FC<FeeCategoryMultiSelectProps> = ({
  categories,
  selectedCategoryIds,
  onChange,
  disabled = false,
}) => {
  const allSelected =
    categories.length > 0 && selectedCategoryIds.length === categories.length;

  const toggleCategory = (categoryId: string) => {
    if (disabled) return;
    onChange(
      selectedCategoryIds.includes(categoryId)
        ? selectedCategoryIds.filter((id) => id !== categoryId)
        : [...selectedCategoryIds, categoryId],
    );
  };

  const selectAll = () => {
    if (disabled) return;
    onChange(categories.map((c) => c.id));
  };

  const clearAll = () => {
    if (disabled) return;
    onChange([]);
  };

  return (
    <div>
      <div className="flex items-center justify-between gap-2 mb-2">
        <label className="block text-sm font-medium text-gray-700">
          Danh mục phí trên thông báo
        </label>
        <div className="flex gap-2 text-xs">
          <button
            type="button"
            onClick={selectAll}
            disabled={disabled || allSelected}
            className="text-blue-600 hover:underline disabled:text-gray-400 disabled:no-underline"
          >
            Chọn tất cả
          </button>
          <span className="text-gray-300">|</span>
          <button
            type="button"
            onClick={clearAll}
            disabled={disabled || selectedCategoryIds.length === 0}
            className="text-blue-600 hover:underline disabled:text-gray-400 disabled:no-underline"
          >
            Bỏ chọn
          </button>
        </div>
      </div>
      <div
        className={`border border-gray-200 rounded-lg p-3 max-h-48 overflow-y-auto space-y-2 ${
          disabled ? 'bg-gray-100 opacity-70' : ''
        }`}
      >
        {categories.map((category) => (
          <label key={category.id} className="flex items-center gap-2 text-sm">
            <input
              type="checkbox"
              checked={selectedCategoryIds.includes(category.id)}
              onChange={() => toggleCategory(category.id)}
              disabled={disabled}
              className="rounded border-gray-300 text-blue-600"
            />
            <span>
              {category.name}
              {category.feeCode ? (
                <span className="text-gray-500 ml-1">({category.feeCode})</span>
              ) : null}
            </span>
          </label>
        ))}
        {categories.length === 0 && (
          <p className="text-sm text-gray-500">Chưa có danh mục phí cho chung cư này.</p>
        )}
      </div>
      <p className="mt-1 text-xs text-gray-500">
        Mặc định gồm tất cả danh mục. Bỏ chọn để chỉ in thông báo một phần (vd. chỉ PQL, không xe).
      </p>
    </div>
  );
};

export default FeeCategoryMultiSelect;
